module.exports = __webpack_public_path__ + "img/Cities_as_places_for_transformation.566c79e5.png";